export type DownloadItem = {
  id: string;
  name: string;
  url?: string;
  type?: 'excel' | 'pdf';
};

export enum DownloadStatus {
  INITIAL = 'initial',
  DOWNLOADING = 'downloading',
  SUCCESS = 'success',
  ERROR = 'error',
}
